module.exports = __webpack_public_path__ + "_/markerclustererplus/images/m1.png";